import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookALFInspectionTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          id: '',
          approvals: [],
          approval: [],
          alf_tool_fod_ok: '',
          alf_tool_fod_na: '',
          modal_justification: false,
          alf_fdm_required: false,
          alf_fdm_yes: false,
          alf_fdm_no: false,
          alf_fdm_justification: '',
          modal_fdm_justification: false,
          pending_fdm_choice: null,
          alf_fdm_input: '',
      };
        this.edit = this.edit.bind(this);
        this.reopen = this.reopen.bind(this);
        this.handleFdmYesChange = this.handleFdmYesChange.bind(this);
        this.handleFdmNoChange = this.handleFdmNoChange.bind(this);
        this.closeFdmModal = this.closeFdmModal.bind(this);
        this.confirmFdmNo = this.confirmFdmNo.bind(this);
        this.updateFdmJustification = this.updateFdmJustification.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = 1;
        } else {
          var value = 0;
        }
        change[name] = value;
        this.setState(change);
      }

      handleCheckboxChange(name, event) {
        if(event.target.checked === false) {
          this.setState({
            alf_tool_fod_ok: false,
            alf_tool_fod_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'alf',
            id: this.state.inspections.id,
            alf_tool_fod_na: false,
            alf_tool_fod_ok: false,
          };
        } else {
          this.setState({
            alf_tool_fod_ok: true,
            alf_tool_fod_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'alf',
            id: this.state.inspections.id,
            alf_tool_fod_na: false,
            alf_tool_fod_ok: true,
          };
      }
      this.edit(datasave);
    }

    handleFdmYesChange(event) {
      if (event.target.checked === false) {
        this.setState({ alf_fdm_yes: true });
        return;
      }

      this.setState({
        alf_fdm_yes: true,
        alf_fdm_no: false,
        alf_fdm_justification: '',
      });

      const datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        inspection_type: 'alf',
        id: this.state.inspections.id,
        alf_fdm: 'yes',
        alf_fdm_justification: null,
      };
      this.edit(datasave);
    }

    handleFdmNoChange(event) {
      if (event.target.checked === false) {
        return;
      }

      this.setState({
        modal_fdm_justification: true,
        pending_fdm_choice: 'no',
        alf_fdm_input: this.state.alf_fdm_justification || '',
      });
    }

    updateFdmJustification(event) {
      this.setState({ alf_fdm_input: event.target.value });
    }

    closeFdmModal() {
      this.setState({
        modal_fdm_justification: false,
        pending_fdm_choice: null,
        alf_fdm_input: '',
      });
    }

    confirmFdmNo() {
      if (!this.state.alf_fdm_input || this.state.alf_fdm_input.trim() === '') {
        this.props.handleAlert('Justification is required to mark FDM as No.', 'error', 'open');
        return;
      }

      const justification = this.state.alf_fdm_input.trim();

      this.setState({
        alf_fdm_yes: false,
        alf_fdm_no: true,
        alf_fdm_justification: justification,
        modal_fdm_justification: false,
        pending_fdm_choice: null,
        alf_fdm_input: '',
      });

      const datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        inspection_type: 'alf',
        id: this.state.inspections.id,
        alf_fdm: 'no',
        alf_fdm_justification: justification,
      };
      this.edit(datasave);
    }
      handleCheckboxNaChange(name, event) {
        if(event.target.checked === false) {
          this.setState({
            alf_tool_fod_ok: false,
            alf_tool_fod_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'alf',
            id: this.state.inspections.id,
            alf_tool_fod_na: false,
            alf_tool_fod_ok: false,
          };
        } else {
          this.setState({
            alf_tool_fod_ok: false,
            alf_tool_fod_na: true,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'alf',
            id: this.state.inspections.id,
            alf_tool_fod_na: true,
            alf_tool_fod_ok: false,
          };
        }
        this.edit(datasave);
      }


      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.inspections !== 'undefined' && newProps.inspections !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            inspections: newProps.inspections,
            id: newProps.inspections.id,
            alf_tool_fod_ok: newProps.inspections.alf_tool_fod_ok,
            alf_tool_fod_na: newProps.inspections.alf_tool_fod_na,
            alf_fdm_required: newProps.inspections.alf_fdm_required || false,
            alf_fdm_yes: newProps.inspections.alf_fdm_yes || false,
            alf_fdm_no: newProps.inspections.alf_fdm_no || false,
            alf_fdm_justification: newProps.inspections.alf_fdm_justification_text || '',
          });
        }

        if(typeof newProps.approvals[7] !== 'undefined' && newProps.approvals[7] !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[7],
            approval: newProps.approvals[7][0],
          });
        }
      }
    
      // Fetch salvando a edição
      edit(datasave) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/inspecao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      reopen(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var datasave = {
          id: this.state.id,
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          justification: this.state.justification,
          inspection_type: 'alf',
          approval_type: this.state.approval.type,
        };
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/inspecao/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({ modal_justification: false, justification: null });
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
      <div className="row">
        <div className="col-md-1 text-center">
          {
            (self.state.approval.status === 1) ?
              <button onClick={() => self.setState({ modal_justification: true })} className="btn btn-primary"><i className="fa fa-fw fa-refresh"></i></button>
            :
              <button onClick={() => {self.props.approve(self.state.approval.id, self.state.approval.type)}} className="btn btn-success"><i className="fa fa-check"></i></button>
          }
        </div>
        <div className="col-md-4">
          <h3 className="page-title pull-left">After Last Flight (ALF) Inspection</h3>
          <div className="clearfix"></div>
        </div>
        <div className="col-md-3">
          <form onSubmit={this.edit}>
            <div className="row">
              {self.state.alf_fdm_required && (
                <div className="col-md-6">
                  <div className="form-group">
                    <label>FDM</label>
                    <br></br>
                    <label>
                      <input
                        name="alf_fdm_yes"
                        type="checkbox"
                        checked={this.state.alf_fdm_yes}
                        onChange={this.handleFdmYesChange}
                      />
                      &nbsp;Yes
                    </label>
                    &nbsp;
                    <label>
                      <input
                        name="alf_fdm_no"
                        type="checkbox"
                        checked={this.state.alf_fdm_no}
                        onChange={this.handleFdmNoChange}
                      />
                      &nbsp;No
                    </label>
                  </div>
                  {self.state.alf_fdm_required && this.state.alf_fdm_justification && (
                    <div className="form-group">
                      <small><strong>Justification:</strong> {this.state.alf_fdm_justification}</small>
                    </div>
                  )}
                </div>
              )}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Tool/FOD
                  </label>
                  <br></br>
                  <label>
                    <input
                      name="alf_tool_fod_ok"
                      type="checkbox"
                      checked={this.state.alf_tool_fod_ok}
                      onChange={this.handleCheckboxChange.bind(this, 'alf_tool_fod_ok')} 
                    />
                    &nbsp;OK
                  </label>
                  &nbsp;
                  <label>
                    <input
                      name="alf_tool_fod_na"
                      type="checkbox"
                      checked={this.state.alf_tool_fod_na}
                      onChange={this.handleCheckboxNaChange.bind(this, 'alf_tool_fod_na')} 
                    />
                    &nbsp;N/A
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <caption>Approval</caption>
              <thead>
                <tr className="text-center">
                  <th>User</th>
                  <th>Status</th>
                  <th>Approval Date</th>
                </tr>
              </thead>
              <tbody id="alf_inspection_approvals">
              {self.state.approvals.map(function(k) {
                  var approval = k;
                  return(
                    <tr className="text-center" key={approval.id}>
                      {
                        (typeof approval.user_id !== 'undefined' && approval.user_id !== null) ?
                        <td>{approval.user_name}</td>
                        :
                        <td></td>
                      }
                      <td>{approval.status_str}</td>
                      <td>{approval.approval_date_str}</td>
                    </tr>
                  );
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <hr/>
      <Modal show={this.state.modal_fdm_justification} aria-labelledby="fdm-justification-modal" bsSize={'large'} onHide={this.closeFdmModal}>
        <Modal.Header closeButton>
          <h4 className="pull-left"><strong>Please justify why FDM was not performed</strong></h4>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Justification</label>
            <textarea
              className="form-control"
              rows={4}
              value={this.state.alf_fdm_input}
              onChange={this.updateFdmJustification}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-default" onClick={this.closeFdmModal}>Cancel</button>
          <button className="btn btn-success" onClick={this.confirmFdmNo}>Confirm</button>
        </Modal.Footer>
      </Modal>
      {/* Modal de justificativa para reabertura */}
      <Modal show={this.state.modal_justification} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left"><strong>Please tell us why you need to reopen this inspection</strong></h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}><i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <p className="alert alert-danger">Attention: This reopening should only be used in case of filling errors. For a new inspection after changing the aircraft's conditions, please open a new logbook.</p>
          <form onSubmit={this.reopen}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Justification:</label>
                  <textarea style={{ height: 200 }} type="text" name="justification" required className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-certificate"></i> Submit justification</button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
    );
  }
}

export default AircraftLogbookALFInspectionTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookALFInspectionTab.js